import React from 'react';
import cn from 'classnames';
import { redirectWithSavingScroll } from 'swag-client-common/utils/tricks';
import AnimationWrapper from 'swag-client-common/components/animation-wrapper';
import classes from './top-products-item.scss';
export const TopProductsItem = ({
  className,
  title,
  text,
  link,
  colorList,
  offset
}) => {
  const buttonStyles = {
    backgroundColor: colorList.button
  };
  const descriptionStyles = {
    backgroundColor: colorList.bgc
  };
  return /*#__PURE__*/React.createElement("div", {
    className: cn(classes.container, classes[className])
  }, /*#__PURE__*/React.createElement(AnimationWrapper, {
    offset: offset
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.image
  }), /*#__PURE__*/React.createElement("div", {
    style: descriptionStyles,
    className: classes.description
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.descriptionTextWrapper
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.title
  }, title), /*#__PURE__*/React.createElement("span", {
    className: classes.text
  }, text)), /*#__PURE__*/React.createElement("button", {
    style: buttonStyles,
    className: classes.button,
    onClick: redirectWithSavingScroll(link)
  }, "Shop now"))));
};